import { render, staticRenderFns } from "./Article2.vue?vue&type=template&id=99574c3a&scoped=true&"
import script from "./Article2.vue?vue&type=script&lang=js&"
export * from "./Article2.vue?vue&type=script&lang=js&"
import style0 from "./Article2.vue?vue&type=style&index=0&id=99574c3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99574c3a",
  null
  
)

export default component.exports